// Scan feedback sounds generated with the Web Audio API, so no audio
// assets are needed and playback works offline.

let audio_context = null

function get_audio_context(){
  if(!audio_context){
    const AudioContextClass = window.AudioContext || window.webkitAudioContext
    if(!AudioContextClass) return null
    audio_context = new AudioContextClass()
  }
  // Browsers suspend audio contexts created before a user gesture. Scans
  // arrive via keyboard/camera after interaction, so resuming here is enough.
  if(audio_context.state === 'suspended') audio_context.resume()
  return audio_context
}

function play_tone(context, { frequency, start, duration, type = 'square', volume = 0.15 }){
  const oscillator = context.createOscillator()
  const gain = context.createGain()

  oscillator.type = type
  oscillator.frequency.value = frequency
  oscillator.connect(gain)
  gain.connect(context.destination)

  const startAt = context.currentTime + start
  const stopAt = startAt + duration

  // Short attack/release ramps avoid audible clicks at tone edges.
  gain.gain.setValueAtTime(0, startAt)
  gain.gain.linearRampToValueAtTime(volume, startAt + 0.005)
  gain.gain.setValueAtTime(volume, stopAt - 0.02)
  gain.gain.linearRampToValueAtTime(0, stopAt)

  oscillator.start(startAt)
  oscillator.stop(stopAt)
}

// Harsh double buzz, similar to a scanner's error tone
export function play_rejection_sound(){
  const context = get_audio_context()
  if(!context) return
  play_tone(context, { frequency: 220, start: 0, duration: 0.15 })
  play_tone(context, { frequency: 160, start: 0.2, duration: 0.25 })
}
